export function formatNumber(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(Number(value))) return '-';
  return Number(value).toFixed(2).replace('.', ',');
}

export function formatYearReference(
  value: string | number | null | undefined,
): string {
  if (value == null || value === '') return '-';
  return String(value);
}

export function formatMetricCell(
  value: number | null | undefined,
  unit = 'tC/ha',
): string {
  return value != null ? `${formatNumber(value)} ${unit}` : '-';
}

export function formatThresholdRange(
  lower: number | null | undefined,
  upper: number | null | undefined,
): string {
  if (lower == null || upper == null) return '-';
  return `${formatNumber(lower)} - ${formatNumber(upper)} tC/ha`;
}

export function parseNumeric(value: unknown): number | null {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function parseYearReference(
  value: unknown,
): string | number | null {
  if (value == null || value === '') return null;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const n = Number(trimmed);
    if (Number.isFinite(n) && String(n) === trimmed) return n;
    return value;
  }
  return null;
}
